export const RESETREQUEST_START = 'RESETREQUEST_START';
export const RESETREQUEST_SUCCESS = 'RESETREQUEST_SUCCESS';
export const RESETREQUEST_FAILURE = 'RESETREQUEST_FAILURE';
